const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case "CLEAR_LICENCE_PAYMENT":
            return initialState;

        case "LICENCE_PAYMENT_RETRIEVED":
            {
                return action.data;
            }

        default:
            return state;
    }
}
